// Navigation.js
import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from '../auth/LoginModal';
import Logo from './Logo';
import DesktopNav from './DesktopNav';
import MobileMenu from './MobileMenu';
import UserMenu from './UserMenu';
import AuthButtons from './AuthButtons';
import AddListingButton from './AddListingButton';

const Navigation = () => {
  const { user, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [notifications] = useState({
    messages: 5,
    alerts: 3,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isUserMenuOpen && !event.target.closest('.user-menu')) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isUserMenuOpen]);

  const handleOpenLogin = () => {
    setIsLoginModalOpen(true);
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsUserMenuOpen(false);
  };

  return (
    <header className="bg-white text-gray-800 sticky top-0 z-50 shadow-md">
      <div className="w-full flex items-center justify-between px-4 lg:px-8 py-4 relative">
        <Logo />
        <DesktopNav user={user} />
        
        <div className="flex items-center gap-3 sm:gap-4 lg:gap-5">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-800 hover:text-gray-600"
            aria-label="Menu mobilne"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>

          <AddListingButton user={user} setIsLoginModalOpen={setIsLoginModalOpen} />

          {user ? (
            <div className="hidden md:block">
              <UserMenu 
                notifications={notifications}
                handleLogout={handleLogout}
                isUserMenuOpen={isUserMenuOpen}
                setIsUserMenuOpen={setIsUserMenuOpen}
              />
            </div>
          ) : (
            <AuthButtons setIsLoginModalOpen={setIsLoginModalOpen} />
          )}
        </div>
      </div>

      <MobileMenu 
        isOpen={isMobileMenuOpen}
        user={user}
        notifications={notifications}
        handleOpenLogin={handleOpenLogin}
        handleLogout={handleLogout}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {isLoginModalOpen && <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />}
    </header>
  );
};

export default Navigation;